import React from 'react'
import SupplyBillFilesBlock from './SupplyBillFilesBlock'

const SupplyBillFiles = ({ supplyBillId }) => {
  return (
    <div>
        <h4>Файли</h4>

        <SupplyBillFilesBlock 
            name='Рахунок'
            tableOwnerId={supplyBillId}
            type='invoice'
        />

    </div>
  )
}

export default SupplyBillFiles